import { createSelector } from '@reduxjs/toolkit';
import {
  PROJECT_PAGE_REDESIGN_DEFAULT,
  PROJECT_PAGE_REDESIGN_SETTING,
} from 'constants/projectPageRedesign';

const selectUserState = (state) => state.user;

export const selectLoggedInUser = createSelector(
  [selectUserState],
  (state) => state.user
);

export const selectUserLoaded = createSelector(
  [selectUserState],
  (state) => state.userLoaded
);

export const selectUserSettings = createSelector(
  [selectUserState],
  (state) => state.settings
);

export const selectUserSettingsLoaded = createSelector(
  [selectUserState],
  (state) => state.settingsLoaded
);

/**
 * Whether the user sees the redesigned projects page: their own choice once
 * they have made one (a boolean in their UserSetting record), the default
 * until then — the classic page (PROJECT_PAGE_REDESIGN_DEFAULT). So only an
 * explicit `true` turns it on; a missing, null or non-boolean value is no
 * choice.
 */
export const selectIsProjectPageRedesignEnabled = createSelector(
  [selectUserSettings],
  (settings) => {
    const value = settings?.[PROJECT_PAGE_REDESIGN_SETTING];
    return typeof value === 'boolean' ? value : PROJECT_PAGE_REDESIGN_DEFAULT;
  }
);
export const selectLoggedInUserId = createSelector(
  [selectUserState],
  (state) => state.user?.id
);

export const selectUserCoordinates = createSelector(
  [selectUserState],
  (state) => state.coordinates
);
export const selectGeolocationError = createSelector(
  [selectUserState],
  (state) => state.geolocationError
);

export const selectIsUpdatingActiveEmployer = createSelector(
  [selectUserState],
  (state) => state.isUpdatingActiveEmployer
);

export const selectUserActiveEmployerId = createSelector(
  [selectUserSettings],
  (settings) => settings.activeEmployerId
);

export const selectUserActiveEmployerBusinessId = createSelector(
  [selectUserSettings],
  (settings) => settings.activeEmployerBusinessId
);

export const selectUserActiveEmployerInfo = createSelector(
  [selectUserActiveEmployerId, selectUserActiveEmployerBusinessId],
  (activeEmployerId, activeEmployerBusinessId) => ({
    activeEmployerId,
    activeEmployerBusinessId,
  })
);

export const selectCurrentUserWorkTimeSaldoItemsEntities = createSelector(
  [selectUserState],
  (state) => state.workTimeSaldoItems.entities
);

export const selectCurrentUserWorkTimeSaldoItemsArray = createSelector(
  [selectCurrentUserWorkTimeSaldoItemsEntities],
  (entities) => Object.values(entities)
);

export const selectCurrentUserWorkTimeSaldoTotalItem = createSelector(
  [selectCurrentUserWorkTimeSaldoItemsArray],
  (workTimeSaldoItems) =>
    workTimeSaldoItems.find((item) => item.date === 'TOTAL')
);
